// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fAmsz","container":"styles_container__6rwqf"};